import { forwardRef, HTMLProps } from 'react'
import Image from 'next/image'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { variantsCards } from '@/shared/constants/variants'
import style from './partners-card.module.scss'

interface PartnersProps extends HTMLProps<HTMLDivElement> {
  svg: string
  index: number
}

export const PartnersCard = forwardRef<HTMLDivElement, PartnersProps>((props, ref) => {
  const { className, svg, index } = props

  return (
    <motion.div
      ref={ref}
      variants={variantsCards}
      custom={index}
      viewport={{ amount: 0.45, once: true }}
      className={clsx(className, 'item', style.card)}
    >
      <Image className={style.svg} src={svg} alt="" fill style={{ objectFit: 'contain' }} />
    </motion.div>
  )
})

PartnersCard.displayName = 'PartnersCard'
